module.exports = __webpack_public_path__ + "static/bennyQuad-83ea01edeffe70c95e97ac3e30ad3a17.jpg";